enum ResultsPageState {
    FETCHING_RESULTS = 'Fetching results',
    FETCHING_DEPOTS = 'Fetching depots',
    COMPLETE = 'Complete',
    IDLE = 'Idle'
}

export default ResultsPageState;
